module.exports = __webpack_public_path__ + "media/images/front/review_star_01-08b5053e200fc6a2657e534e9c07739f.png";